import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent {
  @Input() message: string = '';
  @Input() show: boolean = false;
  @Input() alertType: string = '#8DC881';
  @Output() closed = new EventEmitter<void>();
  @Output() confirmed = new EventEmitter<void>();
  backgroundColor: string;

  @Input() showCancel: boolean = false;
  @Input() showConfirm: boolean = false;

  constructor() {
    switch (this.alertType) {
      case 'success':
        this.backgroundColor = '#8DC881';
        break;
      case 'warning':
        this.backgroundColor = 'orange';
        break;
      case 'error':
        this.backgroundColor = 'red';
        break;
      case 'info':
      default:
        this.backgroundColor = 'blue';
        break;
    }
  }

  get htmlSafeMessage(): string {
    return this.message.replace(/\n/g, '<br>');
  }
  close() {
    this.closed.emit();
  }

  confirm() {
    this.confirmed.emit();
  }
}

// import { Component, Input, Output, EventEmitter } from '@angular/core';

// @Component({
//   selector: 'app-alert',
//   templateUrl: './alert.component.html',
// })
// export class AlertComponent {
//   @Input() message: string = ''; // Mensagem do alerta
//   @Input() showCancel: boolean = false; // Mostrar botão de cancelar
//   @Input() showConfirm: boolean = false; // Mostrar botão de confirmar
//   @Input() alertType: string = 'info'; // Tipo de alerta (pode ser 'info', 'success', 'warning', 'error')
//   @Input() show: boolean = false;

//   backgroundColor: string = 'green'; // Cor de fundo padrão

//   constructor() {
//     // Define a cor de fundo com base no tipo de alerta
//     switch (this.alertType) {
//       case 'success':
//         this.backgroundColor = 'green';
//         break;
//       case 'warning':
//         this.backgroundColor = 'orange';
//         break;
//       case 'error':
//         this.backgroundColor = 'red';
//         break;
//       case 'info':
//       default:
//         this.backgroundColor = 'blue';
//         break;
//     }
//   }

//   close() {
//     this.show = false; // Fecha o alerta
//   }

//   confirm() {
//     // Lógica para confirmar
//     console.log('Confirmado!');
//     this.show = false; // Fecha o alerta após confirmar
//   }
// }
